module.exports = __webpack_public_path__ + "static/img/JP.8128ce8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/JP.svg
// module id = sGB/
// module chunks = 55